
define(function (require) {
    "use strict";

    var LE = require("app");
    var RevisionedModel = require("models/RevisionedModel");
    var ApiResources = require("assets/data/apiResources.json");
    var ContentSystemMessagingEditPageModel = require("content-models/system-messaging/ContentSystemMessagingEditPageModel");
    var ContentSystemMessagingModel = require("content-models/system-messaging/ContentSystemMessagingModel");
    var ContentSystemMessagingUtilities = require("content-utils/ContentSystemMessagingUtilities");

    var ContentSystemMessagingModelAll = {};

    LE.module("LEContent", function (LEContent, LE, Backbone, Marionette, $, _) {

        ContentSystemMessagingModelAll = RevisionedModel.extend({
            name: "ContentSystemMessagingModelAll",
            resource: ApiResources.AccountConfig.SystemMessagingMessages,
            defaults: {
                ACCOUNT: {},
                SKILL: {}
            },
            url: function(){
                var url = RevisionedModel.prototype.url.call(this);
                return url += "&lang="+ LE.siteSettings.supportedLanguageSettings.getSupportedLanguageCodes().join(",") + "&view=BY_CONTEXT";
            },
            initialize: function(options){
                this.accountId = LE.sessionManager.getAccountId();
                RevisionedModel.prototype.initialize.call(this, options);
            },
            getContextAccount: function(){
                LEContent.logger.debug("get account data", "ContentSystemMessagingModelAll:getContextAccount");
                var acModel = new ContentSystemMessagingModel(this.get(ContentSystemMessagingEditPageModel.CONTEXTS.ACCOUNT + "." + this.accountId));

                var defaultModel = LEContent.getDataManager().getDefaultMessagingAutoMessagesModel(this.id);
                var accountContextModel = defaultModel.clone();

                //Merge ID
                accountContextModel.setID(this.id);

                //Merge Languages
                //go over each language found in the AC override - and add/replace it on the defaults
                _.each(acModel.getLanguages(),function(lang){
                    accountContextModel.setContentMessage(lang,acModel.getContentMessage(lang));
                });

                //Merge Enabled ( enabled is initialzed by default to true on the model so we just set what ever is there
                accountContextModel.setEnabledState(acModel.getEnabledState());

                //Merge Attributes
                if (!_.isEmpty(acModel.getAttrs())){
                    accountContextModel.setAttrs(acModel.getAttrs());
                }

                return accountContextModel.toJSON();
            },

            getContextSkill: function(){
                LEContent.logger.debug("get context skills", "ContentSystemMessagingModelAll:getContextSkill");
                return this.get(ContentSystemMessagingEditPageModel.CONTEXTS.SKILL);
            },
            getSkillContext: function(skillId){
                LEContent.logger.debug("get skill data", "ContentSystemMessagingModelAll:getSkillContext. skillId = " + skillId);
                return this.get(ContentSystemMessagingEditPageModel.CONTEXTS.SKILL + "." + skillId);
            },
            addContextSkill: function(skillId, newContextSkill){
                LEContent.logger.debug("add skill", "ContentSystemMessagingModelAll:addContextSkill. skillId = " + skillId + ". newContextSkill = " + newContextSkill);
                this.set(ContentSystemMessagingEditPageModel.CONTEXTS.SKILL + "." + skillId, newContextSkill);
            },
            deleteContextSkill: function(skillId){
                LEContent.logger.debug("delete skill", "ContentSystemMessagingModelAll:deleteContextSkill. skillId = " + skillId);
                this.unset(this.getSkillContext(skillId));
            },
            getContextModelBySkill: function(skillId){
                LEContent.logger.debug("get new context model by skill", "ContentSystemMessagingModelAll:getContextModelBySkill. skillId = " + skillId);
                var existingSkillContext = this.getSkillContext(skillId);
                if(existingSkillContext && skillId && ContentSystemMessagingEditPageModel.DEFAULT_SKILL_NAME !== skillId) {
                    return this.createContextModel(existingSkillContext);
                } else {
                    var accountContext = this.getContextAccount();
                    if(!existingSkillContext && skillId && ContentSystemMessagingEditPageModel.DEFAULT_SKILL_NAME !== skillId) {
                        var accountContextTemp = _.clone(accountContext);
                        accountContextTemp.data = [];
                        return this.createContextModel(accountContextTemp);
                    }
                    return this.createContextModel(accountContext);
                }
            },
            createContextModel: function(content){
                LEContent.logger.debug("create new model according to data and revision", "ContentSystemMessagingModelAll:creteContextModel. content = " + content + ". revision = " + this.getRevision());
                var model = new ContentSystemMessagingModel(content, this.getRevision());
                model.setRevision(this.getRevision(true));

                return model;
            }
        });
    });

    return ContentSystemMessagingModelAll;
});
